"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeIndex = void 0;
const index_1 = require("./../index");
const validating_index_1 = require("./index/validating-index");
//todo: extract to separate package (version detection packages don't need to be included in frontend
class NodeIndex {
    constructor(network) {
        this._network = network;
        this._versionIndex = new index_1.VersionIndex(this._network.nodes);
        this._trustIndex = new index_1.TrustIndex(this._network);
    }
    getIndex(node) {
        return Number(((index_1.TypeIndex.get(node)
            + index_1.ActiveIndex.get(node)
            + validating_index_1.ValidatingIndex.get(node)
            + this._versionIndex.get(node)
            + this._trustIndex.get(node)
            + index_1.AgeIndex.get(node)) / 6).toFixed(2));
    }
}
exports.NodeIndex = NodeIndex;
//# sourceMappingURL=node-index.js.map